var exports = {
  "wx": "MobileSettingsComponents.module__header___U1p3em",
  "VW": "MobileSettingsComponents.module__headerContent___U1p3em",
  "Gv": "MobileSettingsComponents.module__backButton___U1p3em",
  "dR": "MobileSettingsComponents.module__backButtonIcon___U1p3em",
  "qd": "MobileSettingsComponents.module__headerTitle___U1p3em",
  "AN": "MobileSettingsComponents.module__headerSpacer___U1p3em",
  "wV": "MobileSettingsComponents.module__settingsList___U1p3em",
  "Wk": "MobileSettingsComponents.module__categoryContainer___U1p3em",
  "Km": "MobileSettingsComponents.module__categoryHeader___U1p3em",
  "$L": "MobileSettingsComponents.module__categoryTabs___U1p3em",
  "Ol": "MobileSettingsComponents.module__dangerButton___U1p3em",
  "ED": "MobileSettingsComponents.module__dangerButtonPressed___U1p3em",
  "hh": "MobileSettingsComponents.module__dangerIcon___U1p3em",
  "RJ": "MobileSettingsComponents.module__dangerContent___U1p3em",
  "S4": "MobileSettingsComponents.module__dangerLabel___U1p3em",
  "eg": "MobileSettingsComponents.module__tabButton___U1p3em",
  "EQ": "MobileSettingsComponents.module__tabButtonPressed___U1p3em",
  "Ll": "MobileSettingsComponents.module__tabIcon___U1p3em",
  "Lj": "MobileSettingsComponents.module__tabContent___U1p3em",
  "Gn": "MobileSettingsComponents.module__tabLabel___U1p3em",
  "RQ": "MobileSettingsComponents.module__tabArrow___U1p3em",
  "ZI": "MobileSettingsComponents.module__tabDivider___U1p3em",
  "qr": "MobileSettingsComponents.module__footer___U1p3em",
};

module.exports = exports;
